export default __webpack_public_path__ + "8aafb459a59da4ee35fd5dbf87347011.png";